import Vue from 'vue'
import axios from 'axios'
import { get } from 'lodash'

import store from '@/store'
import router from '@/router'
import config from '@/config'

let http = axios.create({
  timeout: 30000,
  baseURL: config.baseURL
})

http.interceptors.request.use(config => {
  store.commit('app/incRequestsCount')
  return config
})

http.interceptors.response.use(
  response => {
    store.commit('app/decRequestsCount')

    if (response.errors) {
      throw response
    }

    return response.data
  },
  error => {
    Vue.$log.error('HTTPException: ' + error)
    store.commit('app/decRequestsCount')

    // На случай, если Тимурчик не прислал ошибку
    let serverError = get(error, 'response.data.errors', null)
    if (null === serverError) {
      store.commit('app/showSnack', 'Произошла непредвиденная ошибка')
    }

    switch (error.response.status) {
      case 401:
        store.commit('auth/logout')
        break
      case 404:
        router.replace({ name: '404' })
        break
      case 403:
        router.replace({ name: '403' })
        break
      case 400:
        if ('token_invalid' === get(error, 'response.data.error')) {
          store.commit('auth/logout')
        }
    }

    throw error
  }
)

export function setHttpToken(token) {
  http.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

export function HTTPException(message) {
  this.response = {
    data: {
      errors: message
    }
  }
}

export default http
